<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? 'Add Certificate' : 'Edit Certificate'}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? 'Add Certificate' : 'Edit Certificate'}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Certificate</h6>
            </div>
            <div v-if="showVideo === true">
              <ValidationObserver ref="currencyAddForm" id="currencyAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="user_id" class="form-label">User:</label>
                    <multiselect v-model="formData.bought_by_user" placeholder="Select user" :disabled="isEdit" id="user_id" label="first_name" :class="classes"  :close-on-select="true" track-by="id" :options="users">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.first_name}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.first_name}}</span>
                      </template>
                    </multiselect>
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="currency_id" class="form-label">Currency:</label>
                    <multiselect v-model="formData.currency" placeholder="Select Currency" :custom-label="customLabel" id="currency_id" label="name_l" :class="classes"  :close-on-select="true" track-by="id" :options="currencies">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.name_l[$i18n.locale]}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.name_l[$i18n.locale]}}</span>
                      </template>
                    </multiselect>
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="amount_id" class="form-label">Amount:</label>
                    <input id="amount_id" class="form-control" name="amount_id" v-model="formData.amount" placeholder="Amount" :class="classes" type="text">
                  </ValidationProvider>
                  <ValidationProvider tag="div" v-slot="{ classes }" class="form-group">
                    <label for="base_certificate_id" class="form-label">Base certificate:</label>
                    <multiselect v-model="formData.base_certificate" placeholder="Select base certificate" id="base_certificate_id" label="title" :class="classes"  :close-on-select="true" track-by="id" :options="base_certificates">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.title}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.title}}</span>
                      </template>
                    </multiselect>
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="paid_at" class="form-label">Paid at</label>
                    <input id="paid_at" class="form-control" name="paid_at" v-model="formData.paid_at" :class="checkValidation(classes)" type="datetime-local">
                  </ValidationProvider>
                  <ValidationProvider tag="div" v-slot="{ classes }" class="form-group">
                    <label for="comment_id" class="form-label">Comment:</label>
                    <textarea id="comment_id" class="form-control" name="comment_id" v-model="formData.comment" placeholder="Comment" :class="classes" type="text"></textarea>
                  </ValidationProvider>
                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'CurrencyAdd',
  data () {
    return {
      showVideo: false,
      isEdit: false,
      buttonDisable: false,
      data: '',
      lang: {
        formatLocale: {
          firstDayOfWeek: 1
        },
        monthBeforeYear: false
      },
      formData: {
        paid_at: moment()
      },
      isCreate: false,
      currencies: [],
      base_certificates: [],
      users: [],
      cookieId: ''
    }
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages,
      itemData: state => state.certificate.itemData
    })
  },
  created () {
    this.getCreateData().then((res) => {
      this.currencies = res.currencies
      this.base_certificates = res.base_certificates
      this.users = res.users
    })
    this.cookieId = this.$route.params.id
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
    } else {
      this.isEdit = true
      this.getData({ id: this.cookieId }).then(res => {
        this.showVideo = true
        this.formData = this.itemData
        if (this.formData.paid_at) {
          this.formData.paid_at = moment(this.formData.paid_at).format('YYYY-MM-DD hh:mm:ss')
        }
      })
    }
  },
  methods: {
    ...mapActions({
      getAllCurrency: 'currency/getAllCurrency',
      create: 'certificate/create',
      getCreateData: 'certificate/getCreateData',
      update: 'certificate/update',
      getData: 'certificate/getData'
    }),
    customLabel (data) {
      return `${data.name_l[this.$i18n.locale]}`
    },
    checkValidation (data) {
      return data
    },
    formSubmit () {
      this.$refs.currencyAddForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          if (this.formData.paid_at) {
            this.formData.paid_at = moment(this.formData.paid_at).format('YYYY-MM-DD hh:mm:ss')
          }
          this.formData.bought_by_user_id = this.formData.bought_by_user.id
          this.formData.currency_id = this.formData.currency.id
          delete this.formData.bought_by_user
          delete this.formData.currency
          delete this.formData.base_certificate
          if (this.isCreate === true) {
            this.create(this.formData).then(() => {
              this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
              this.$router.push('/certificate')
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            this.update({ data: this.formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.courseUpdated')).goAway(1500)
              this.$router.push('/certificate')
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
